import React, {useState} from 'react'
import "./ProductList.css"
import { useStateValue } from './StateProvider';
import 'font-awesome/css/font-awesome.min.css'; 


function Product({id, title, image, price, rating}) {
    const [{basket},dispatch] = useStateValue();
    
    React.useEffect(() => {
        localStorage.setItem("count", basket)
      }, [basket])

    const addToBasket = () => {
dispatch({
    type: 'ADD_TO_BASKET',
    item:{
        id: id,
        title: title,
        image: image,
        price: price,
        rating: rating,
        
    
    },
});
    };

    const [love,setlove] = useState(true);
console.log(love)
    const useHeart = (event) => {
        setlove(event.target.love = !love);
        
    }
    return (
        <div className="product1">
            <div classname="heart" onClick = {useHeart}><i className="fa fa-heart" style= {!love ? {color:'red'} :  {color:'grey'}}/></div>
            <img src={image} alt=""/>
            <div className= "product_info1">
                <strong>{title}</strong>
                <p className= "product_price1">
                    <small>$</small>
                    <span>{price}</span>
                </p>
                
            </div>
        <button className= "addToBasket" onClick= {addToBasket}><i class="fa fa-shopping-bag2x"/> Agregar al carrito</button>
        </div>
    );
}

export default Product
